import type { WorldState } from '../world/state/types';

export interface TsukimachiProbe {
  ready: boolean;
  /** Dev/preview only: the latest WorldState, for the screenshot harness and debugging. */
  state?: WorldState;
}

declare global {
  interface Window {
    __tsukimachi?: TsukimachiProbe;
  }
}

export function initProbe(): TsukimachiProbe {
  window.__tsukimachi = { ready: false };
  return window.__tsukimachi;
}
